module.exports = __webpack_public_path__ + "fc3dd01c9c3a23ca43373af9c75b7164.png";